


















import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Dialog extends Vue {
  dialogVisible: boolean = false
  dialogTitle: string = ''
  dialogMessage: string = ''
  dialogCallback: (value: boolean)=>void = (value)=>{}

  showDialog (title: string, message: string, callback:(value:boolean)=>void) {
    this.dialogTitle = title
    this.dialogMessage = message
    this.dialogCallback = callback
    this.dialogVisible = true
  }

  onCloseDialog (value: boolean) {
    this.dialogCallback(value)
    this.dialogVisible = false
  }
}
